import { Stack, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'

import { getStorage } from '../api'

export const DevReleaseInfo = () => {
  const theme = useTheme()
  const bgcolor = theme.palette.primary.dark
  const color = theme.palette.primary.contrastText

  const [buildInfo, setBuildInfo] = useState(null)
  useEffect(() => setBuildInfo(getStorage('buildInfo')), [])

  const env = buildInfo?.environment
  const branch = buildInfo?.branch
  const build = buildInfo?.build

  const isProd = env === 'production'
  const isMaster = branch === 'master'
  // in case of deployment rollback, by setting a specific commit, the branch name is HEAD
  const isHEAD = branch === 'HEAD'

  const isRelease = isProd && (isMaster || isHEAD)

  return !isRelease ? (
    <Stack
      sx={{
        bgcolor,
        bottom: 0,
        color,
        position: 'absolute',
        px: 1,
        textAlign: 'center',
        width: '100%',
      }}
    >
      <Typography sx={{ fontSize: 12 }}>branch : {branch}</Typography>
      <Typography sx={{ fontSize: 12 }}>env : {env}</Typography>
      <Typography sx={{ fontSize: 12 }}>build : {build}</Typography>
    </Stack>
  ) : null
}
